<template>
    <td>
        <input ref="chbox" type="checkbox" class="uk-checkbox" @click="checkTheBox" />
    </td>
</template>

<script>
    export default {
        name: 'data-table-select',
        components: {

        },
        props: {
            cell_data: {
                type: Object,
                default: () => {}
            },
            id_field: {
                type: String,
                default: 'id'
            },
            selected_ids: {
                type: Array,
                default: () => []
            },
            all_checked: {
                type: Boolean,
                default: false
            }
        },
        data(){
            return {

            }
        },
        mounted(){
            this.$refs.chbox.checked = this.selected_ids.indexOf(this.getId) !== -1 || this.all_checked;
        },
        methods: {
            checkTheBox(){
                if(this.$refs.chbox.checked){
                    this.selected_ids.push(this.getId);
                } else {
                    let i = this.selected_ids.indexOf(this.getId);
                    this.selected_ids.splice(i, 1);
                }
            }
        },
        computed: {
            getId(){
                return this.cell_data[this.id_field];
            }
        },
        watch:{
            all_checked(){
                this.$refs.chbox.checked = this.selected_ids.indexOf(this.getId) !== -1 || this.all_checked;
            }
        }
    }
</script>
